export const environment = {
    production: true,
    ApiUrl: 'https://pwa.api.motorcentral.co.nz/api/v1/',
    ApiUrlReporting: 'https://connect.motorcentral.co.nz/api/v1/',
    ClientId: "5237492B-A9EA-44AF-BCBF-415D77359282",
    biometricExpiryMinutes: 360,
    forceBiometricForTesting: false,
    buildName: 'test',
    serviceWorker: true,
    pwaFirebase: null
};
